import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-view-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M9.76667 0H3.56667C0.833333 0 0 0.833334 0 3.56667V7.28667C0 10.02 0.833333 10.8533 3.56667 10.8533H9.76667C12.5 10.8533 13.3333 10.02 13.3333 7.28667V3.56667C13.3333 0.833334 12.5 0 9.76667 0ZM11.16 6.17333C11.16 7.67333 10.46 8.37333 8.96 8.37333H7.47333C5.97333 8.37333 5.27333 7.67333 5.27333 6.17333V4.68667C5.27333 3.18667 5.97333 2.48667 7.47333 2.48667H8.96C10.46 2.48667 11.16 3.18667 11.16 4.68667V6.17333Z"
        fill="currentColor" />
    </svg>
  `,
})
export class ViewIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 14 11');
}
